import { trendingItems } from '@/mocks/trending';

export default function TrendingSection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              Trending Now
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
              Trending PandaBuySpreadsheet Lists
            </h2>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Spreadsheets
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {trendingItems.map((item, idx) => (
            <a
              key={item.title}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-xl p-5 md:p-6 cursor-pointer hover:bg-background-200/50 transition-colors duration-300 border border-background-200/50"
            >
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className={`text-accent-600 text-sm ${idx === 0 ? 'ri-footprint-line' : idx === 1 ? 'ri-t-shirt-line' : idx === 2 ? 'ri-vip-crown-2-line' : 'ri-fire-line'}`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}